import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header4 from '../header4/Header4';
import Footer2 from '../Cyber-Security-Components/Footer/Footer2';
import Scrollbar from '../scrollbar/scrollbar';

const MinimalFooter = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language || 'en';

    return (
        <footer style={{
            background: '#080c27',
            padding: '30px 0',
            borderTop: '1px solid rgba(255, 255, 255, 0.06)'
        }}>
            <div className="container">
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    <p style={{
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: '13px',
                        margin: 0
                    }}>
                        © {new Date().getFullYear()} OrbitroniX. All rights reserved.
                    </p>
                    <ul style={{
                        display: 'flex',
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        gap: '24px'
                    }}>
                        <li>
                            <Link to={`/${lang}/privacy-policy`} style={{
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '13px',
                                textDecoration: 'none',
                                transition: 'color 0.3s'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#fff'}
                            onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.5)'}
                            >Privacy Policy</Link>
                        </li>
                        <li>
                            <Link to={`/${lang}/terms-conditions`} style={{
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '13px',
                                textDecoration: 'none',
                                transition: 'color 0.3s'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#fff'}
                            onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.5)'}
                            >Terms of Use</Link>
                        </li>
                        <li>
                            <Link to={`/${lang}/support`} style={{
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '13px',
                                textDecoration: 'none',
                                transition: 'color 0.3s'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#fff'}
                            onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.5)'}
                            >Support</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

const Layout = ({ children, hideScrollbar, className, minimalFooter, fullHeight }) => {
    return (
        <div className={`orbitronix body_wrap${className ? ' ' + className : ''}`} style={fullHeight ? { display: 'flex', flexDirection: 'column', minHeight: '100vh' } : {}}>
            <Header4 />
            <div style={fullHeight ? { flex: 1, display: 'flex', flexDirection: 'column' } : {}}>
                {children}
            </div>
            {minimalFooter ? <MinimalFooter /> : <Footer2 />}
            {!hideScrollbar && <Scrollbar />}
        </div>
    );
};

export default Layout;
